// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  overflow: hidden !important;
  max-height: unset !important;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
  justify-content: flex-end !important;
  min-height: unset !important;
}

.content {
  padding: 10px;
  border-radius: 4px;
  overflow: hidden;
}

.button-gap {
  gap: 12px;
}

.content ::ng-deep .table-container {
  max-height: 55vh;
}

.content ::ng-deep .table-container::-webkit-scrollbar {
  width: 6px;
}

.content ::ng-deep .table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.content ::ng-deep .table-container::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/notes-dialog/notes-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["mat-dialog-content {\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  overflow: hidden !important;\n  max-height: unset !important;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n  justify-content: flex-end !important;\n  min-height: unset !important;\n}\n\n.content {\n  padding: 10px;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.content ::ng-deep .table-container {\n  max-height: 55vh;\n}\n\n.content ::ng-deep .table-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.content ::ng-deep .table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.content ::ng-deep .table-container::-webkit-scrollbar-thumb {\n  background: #aaa;\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
